import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { constants } from 'constants/constants';
import { STEP_COLOR_STATUSES, STEP_TYPES } from 'constants/status.constants';
import { ComputedFrom } from '@certemy/common';
import { isRollingAuditStep } from 'features/professional-step/education/ce-types/general/general-ce-type.component.helpers';
import _get from 'lodash-es/get';
import { isStepSubmitted } from 'utils/step.helpers';

@Component({
  selector: 'cm-step-header',
  templateUrl: './step-header.component.html',
  styleUrls: ['./step-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepHeaderComponent {
  @Input() data;
  @Input() isSmall = false;
  @Input() template: TemplateRef<any>;
  readonly constants = constants;
  readonly STEP_TYPES = STEP_TYPES;
  readonly statuses = STEP_COLOR_STATUSES;
  readonly isStepSubmitted = isStepSubmitted;

  @ComputedFrom('data')
  get isEducationStep(): boolean {
    return this.data.step_type_id === STEP_TYPES.EDUCATION;
  }

  @ComputedFrom('data')
  get statusName(): string {
    const isAuditStep = isRollingAuditStep(this.data);
    if (isAuditStep) {
      const auditStatusId = _get(this.data, 'content.auditStatusId', null);
      return auditStatusId
        ? constants.STEP_AUDIT_STATUS_NAMES[auditStatusId]
        : constants.STEP_TYPE_STATUS_NAMES[constants.STEP_TYPE_STATUSES.PENDING_VERIFICATION];
    }
    const statusNames = {
      ...constants.STEP_TYPE_STATUS_NAMES,
      [constants.STEP_TYPE_STATUSES.PASSED_DUE_DATE]: 'Past due date',
    };
    return statusNames[this.data.status_id];
  }
}
